import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import zIndex from '@material-ui/core/styles/zIndex';
import LocationIcon from '../../assets/image/location.png';
import InstagramIcon from '../../assets/image/instagram.png';
import PhoneIcon from '../../assets/image/phone.png';
import ShopIcon from '../../assets/image/shop.png';
import CloseIcon from '../../assets/image/close.png';
import CheckIcon from '../../assets/image/f-check.png';
import _ from 'lodash';
import { seller } from '../../config/api';

import GAEvent from '../../utils/googleAnalytics';

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 999,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px 20px',
    
  },
  content: {
    inset: 0,
    width: 858,
    height: '100%',
    position: 'relative',
    borderRadius: '24px',
    padding: '40px 0 20px',
    left: 0,
    top: 20
  }
};

const ModalContainer = styled.div`
  width: 100%;
`

const CloseButton = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 48px;
  position: absolute;
  right: 30px;
  top: 30px;
  background-color: white;
  border: none;
  outline: none;
  box-shadow: 0 0.5rem 1.2rem rgba(0, 0, 0, 0.1);
  padding: 10px;
  cursor: pointer;
`

const ModalContent = styled.div`
  width: 100%;
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  /* justify-content: center;
  align-items: center; */
  @media (max-width: 768px) {
    margin-top: 30px;
  }
`

const ImageArea = styled.div`
  width: 150px;
  height: 150px;
  background: black;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  padding: 10px;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    margin-top: 30px;
    width: 100px;
    height: 100px;
  }
`

const SellerName = styled.div`
  color: #74777E;
  font-size: 18px;
  font-weight: 600;
`

const SellerInfo = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
  @media (max-width: 768px) {
    padding: 0 20px;
  }
`

const IconWidth = styled.p`
  width: 24px;
  height: 24px;
  margin-right: 15px;
  @media (max-width: 768px) {
    width: 18px;
    height: 18px;
    margin-right: 10px;
  }
`

const SellerInfoSection = styled.div`
  /* margin-right: 40px;
  padding-right: 40px;
  border-right: 2px solid #748FB5; */
  display: flex;
  flex-direction: column;
  flex: 1;
  @media (max-width: 768px) {
    width: 100%;
  }
`

const SellerInfoText = styled.p`
  font-weight: 600;
  color: #111029;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`

const SellerInfoContainer = styled.div`
  width: 600px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`

const ItemLinkButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  border: none;
  outline: none;
  background-color: white;
  padding: 0;
  cursor: pointer;
`

const SellerWebLinkButton = styled.button`
  background-color: #FF6E30;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: white;
  font-size: 20px;
  padding: 16px 20px;
  outline: none;
  border: none;
  border-radius: 16px;
  font-weight: 600;
  cursor: pointer;
  @media (max-width: 768px) {
    font-size: 16px;
    padding: 12px 16px;
  }
`

const FlextStart = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
`

const ItemListWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
`

const ItemListText = styled.p`
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 20px;
`

export default ({modalIsOpen, modalIsClose, sellerInfo, sellerItems}) => {

  const _goSellerItemLink = async (o) => {
    GAEvent('Link', '아이템 링크', `${o?.sellerId} ${o?.url}`);
    window.open(o?.url, '_blank');

    try {
      await seller.sellerItemViewCount(o?.sellerId);
    } catch (e) {
      console.log(e);
    }
  }

  const _goSellerWebSite = (sellerInfo) => {
    GAEvent('Link', '웹사이트', `${sellerInfo?.name} ${sellerInfo?.website}`);
    window.open(sellerInfo?.website, '_blank');
  }

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        style={customStyles}
        onRequestClose={() => modalIsClose()}
      >
        <ModalContainer>
          <CloseButton onClick={() => modalIsClose()}>
            <img style={{width: '100%'}} src={CloseIcon} />
          </CloseButton>
          <ModalContent>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: 40}}>
              <ImageArea>
                <img style={{width: '100%'}} src={sellerInfo?.picture}/>
              </ImageArea>
              <SellerName>
                {sellerInfo?.name}
              </SellerName>
            </div>
            {/* <div>
              <div>
                <p>
                  타임블루는 “고유한 정체성이 고양되는 즐거운 경험을 함께한다” 것을 기치로 설립된
                  명품시계 전문 유통기업입니다. 기술을 예술로 승화한 워치메이커의 숭고한 정신과
                  정체성의 완성을 추구하는 워치러버의 감성에 깊은 존경을 표하며, 장인정신과 고객의 만남이
                  더욱 활성화 될 수 있도록 명품시계 시장의 합리적 성장에 작은 역할이나마 기여하고자 합니다.
                </p>
              </div>
            </div> */}
            <SellerInfo>
              <SellerInfoContainer>
                <SellerInfoSection>
                  <FlextStart>
                    <IconWidth>
                      <img style={{width: '100%'}} src={LocationIcon} />
                    </IconWidth>
                    <SellerInfoText>
                      {sellerInfo?.si} {sellerInfo?.gu}
                    </SellerInfoText>
                  </FlextStart>
                  <FlextStart style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <IconWidth>
                      <img style={{width: '100%'}} src={PhoneIcon} />
                    </IconWidth>
                    <SellerInfoText>
                      {sellerInfo?.phoneNumber}
                    </SellerInfoText>
                  </FlextStart>
                </SellerInfoSection>
                <SellerInfoSection>
                  <FlextStart>
                    <IconWidth>
                      <img style={{width: '100%'}} src={ShopIcon} />
                    </IconWidth>
                    <SellerInfoText style={{cursor: 'pointer'}} onClick={() => _goSellerWebSite(sellerInfo)}>
                      {sellerInfo?.website}
                    </SellerInfoText>
                  </FlextStart>
                  <FlextStart style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <IconWidth>
                      <img style={{width: '100%'}} src={InstagramIcon} />
                    </IconWidth>
                    <SellerInfoText style={{cursor: 'pointer'}} onClick={() => window.open(sellerInfo?.instagram, '_blank')}>
                      {sellerInfo?.instagram}
                    </SellerInfoText>
                  </FlextStart>
                </SellerInfoSection>
              </SellerInfoContainer>
            </SellerInfo>
            <ItemListWrap>
              <div style={{width: 600}}>
                <ItemListText>
                  보유 물건
                </ItemListText>
                <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between'}}>
                  {sellerItems?.map((o) => {
                    return (
                      <ItemLinkButton onClick={() => _goSellerItemLink(o)}>
                        <p style={{width: 130, marginBottom: 5, height: 250, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                          {!_.isNil(o?.Item?.image) ?(
                            <img style={{width: '100%', resizeMode: "cover"}} src={o?.Item?.image} />
                          ) : (
                            <p>
                              이미지 준비 중 입니다.
                            </p>
                          )}
                          
                        </p>
                        <p style={{marginBottom: 5, fontWeight: 600}}>
                          {o?.Item?.name}
                        </p>
                        <p style={{fontSize: 14}}>
                          {o?.Item?.category3}
                        </p>
                      </ItemLinkButton>
                    )
                  })}
                </div>
              </div>
            </ItemListWrap>
            <ItemListWrap style={{marginTop: 20}}>
              <div style={{width: 600}}>
                <p style={{color: '#808191', fontSize: 12}}>
                  * 클릭시 해당 홈페이지 물품으로 연결됩니다.
                </p>
              </div>
            </ItemListWrap>
            <ItemListWrap style={{marginTop: 30}}>
              <div style={{width: 600, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <SellerWebLinkButton onClick={() => _goSellerWebSite(sellerInfo)}>
                  <p>
                    홈페이지 방문
                  </p>
                  <p style={{width: 20, marginLeft: 5}}>
                    <img style={{width: '100%'}} src={CheckIcon} />
                  </p>
                </SellerWebLinkButton>
              </div>
            </ItemListWrap>
          </ModalContent>
        </ModalContainer>
      </Modal>
    </>
  )
}